<div class='body'>

  @if (listsLoading) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }

  <mat-card class='cardContent'>

    <app-lcd-display [number]='pesoBascula' [activeColor]='colorBascula' [height]='heightBascula' [width]='widthBascula' [disabledColor]='disabledColorBascula' [maxNumberLength]='maxNumberLengthBascula'></app-lcd-display>

    @if (isSaving) {
      <div class='savingStatus' role='status'>
        <mat-icon class='savingStatusIcon'>hourglass_top</mat-icon>
        <span>{{ getSaveDisabledReason() }}</span>
      </div>
    }

    @if (!listsLoading && !socketConnected) {
      <div class='connectionAlert connectionAlertSocket' role='alert'>
        <mat-icon class='connectionAlertIcon'>cloud_off</mat-icon>
        <div class='connectionAlertText'>
          <span class='connectionAlertTitle'>Sin conexión con el servidor socket</span>
          <span class='connectionAlertHint'>Compruebe la red y la configuración del socket en Ajustes.</span>
        </div>
      </div>
    }

    @if (!listsLoading && socketConnected && !basculaConnection) {
      <div class='connectionAlert' role='alert'>
        <mat-icon class='connectionAlertIcon'>link_off</mat-icon>
        <div class='connectionAlertText'>
          <span class='connectionAlertTitle'>Sin conexión con {{ selectedScaleLabel() }}</span>
          <span class='connectionAlertHint'>Compruebe que la aplicación de control esté abierta.</span>
        </div>
      </div>
    }

    @if (loadErrors.scales || loadErrors.camiones || loadErrors.materiales) {
      <div class='loadErrorAlert' role='alert'>
        @if (loadErrors.scales) {
          <p>{{ loadErrors.scales }}</p>
        }
        @if (loadErrors.camiones) {
          <p>{{ loadErrors.camiones }}</p>
        }
        @if (loadErrors.materiales) {
          <p>{{ loadErrors.materiales }}</p>
        }
      </div>
    }

    <form [formGroup]="form">
      @if (scales.length > 1) {
        <mat-form-field class='formField'>
          <mat-label>Báscula</mat-label>
          <mat-select formControlName="scaleId" required (selectionChange)="onScaleChange()" [disabled]="!!loadErrors.scales || listsLoading">
            @for (scale of scales; track scale.id) {
              <mat-option [value]="scale.id">{{scale.name}}</mat-option>
            }
          </mat-select>
          <mat-error>
            @if (form.get('scaleId')?.hasError('required')) {
              Debes seleccionar una báscula.
            }
          </mat-error>
        </mat-form-field>
      }
      <mat-form-field class='formField'>
        <mat-label>Camión</mat-label>
        <mat-select formControlName="matricula" required [disabled]="!!loadErrors.camiones || listsLoading">
          @for (camion of camiones; track camion.id) {
            <mat-option [value]="camion.id">{{camion.matricula}}</mat-option>
          }
        </mat-select>
        <mat-error>
          @if (form.get('matricula')?.hasError('required')) {
            Debes seleccionar un camión.
          }
        </mat-error>
      </mat-form-field>
      <mat-form-field class='formField'>
        <mat-label>Nº Albarán</mat-label>
        <input matInput type="number" placeholder="Nº Albarán" formControlName="nAlbaran" required>
        <mat-error>
          @if (form.get('nAlbaran')?.hasError('required')) {
            Debes poner un Nº de Albarán.
          } @else if (form.get('nAlbaran')?.hasError('pattern')) {
            Debe ser un número.
          }
        </mat-error>
      </mat-form-field>
      <mat-form-field class='formField'>
        <mat-label>Residuo</mat-label>
        <mat-select formControlName="material" required [disabled]="!!loadErrors.materiales || listsLoading">
          @for (material of materiales; track material.id) {
            <mat-option [value]="material.id">{{material.nombre}}</mat-option>
          }
        </mat-select>
        <mat-error>
          @if (form.get('material')?.hasError('required')) {
            Debes seleccionar un material.
          }
        </mat-error>
      </mat-form-field>
      <mat-form-field class='formField'>
        <mat-label>Observaciones</mat-label>
        <input matInput placeholder="Observaciones" formControlName="observaciones">
      </mat-form-field>
    </form>

    <div class='actionBlock'>
      <button
        mat-raised-button
        color='primary'
        type="button"
        (click)="saveData()"
        [disabled]="isSaveDisabled()">
        <mat-icon>save</mat-icon>
        Guardar datos
      </button>

      @if (getSaveDisabledReason() && !isSaving) {
        <p class='saveHint'>{{ getSaveDisabledReason() }}</p>
      }
    </div>

  </mat-card>
</div>
